"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FacilitiesItem = _interopRequireDefault(require("../FacilitiesItem"));
var _hotel = require("../../proptypes/hotel");
var _MobilePopup = _interopRequireDefault(require("../MobilePopup"));
var _excluded = ["items", "isMobile"];
var MOBILE_MODAL_OPTIONS = {
  showCloseIcon: false
};
var HotelFacilitiesPopup = function HotelFacilitiesPopup(_ref) {
  var items = _ref.items,
    isMobile = _ref.isMobile,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return isMobile ? /*#__PURE__*/_react["default"].createElement(_MobilePopup["default"], (0, _extends2["default"])({}, rest, {
    label: /*#__PURE__*/_react["default"].createElement(StyledLabel, null, "\u0427\u0442\u043E \u0435\u0441\u0442\u044C \u0432\u043E \u0432\u0441\u0435\u0445 \u043D\u043E\u043C\u0435\u0440\u0430\u0445"),
    options: MOBILE_MODAL_OPTIONS,
    showCloseButton: true,
    zIndex: 11001
  }), /*#__PURE__*/_react["default"].createElement(StyledContainer, null, /*#__PURE__*/_react["default"].createElement(StyledHeader, null, "\u0412\u043E \u0432\u0441\u0435\u0445 \u043D\u043E\u043C\u0435\u0440\u0430\u0445"), items.map(function (_ref2) {
    var name = _ref2.name,
      type = _ref2.type;
    return /*#__PURE__*/_react["default"].createElement(StyledFacilitiesItem, {
      key: name,
      showCheck: true,
      icon: type
    }, name);
  }))) : null;
}; // TODO: non mobile popups

HotelFacilitiesPopup.propTypes = {
  className: _propTypes["default"].string,
  items: _propTypes["default"].arrayOf(_hotel.RoomFacilityPropTypes).isRequired,
  isMobile: _propTypes["default"].bool
};
HotelFacilitiesPopup.defaultProps = {
  className: '',
  isMobile: false
};
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelFacilitiesPopup__StyledLabel",
  componentId: "sc-q86yfp-0"
})(["color:var(--secondary);font-size:13px;"]);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelFacilitiesPopup__StyledContainer",
  componentId: "sc-q86yfp-1"
})(["padding-bottom:15px;"]);
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "HotelFacilitiesPopup__StyledHeader",
  componentId: "sc-q86yfp-2"
})(["font-size:15px;margin-top:3px;margin-bottom:15px;font-weight:500;color:", ";"], function (props) {
  return props.theme.colors.blackBase;
});
var StyledFacilitiesItem = (0, _styledComponents["default"])(_FacilitiesItem["default"]).withConfig({
  displayName: "HotelFacilitiesPopup__StyledFacilitiesItem",
  componentId: "sc-q86yfp-3"
})(["font-size:13px;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelFacilitiesPopup);